<template>
    <div class="video-editor-page" id="video-editor-page">

        <app-loading 
            v-if="loading"
        />

        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            is_timer="true"
            :currentDuration="currentDuration"
            :allDuration="allDuration"
            @clickBack="$router.push('/')"
            @clickMenu="change_menu(context, true)"
        />

<!--        <app-player-editor-->
<!--            :key="videos_component_key"-->
<!--            :videos="videos"-->
<!--        />-->

<!--        <new-player-->
<!--            v-if="readyState"-->
<!--          :videos="videos"-->
<!--          @loadingComplete="rendering = true"-->
<!--          :key="videos_component_key"-->
<!--          @changeKey="videos_component_key = `f${(~~(Math.random()*1e8)).toString(16)}`"-->
<!--        />-->

        <app-player-no-blob
            v-if="readyState"
            :videos="videos"
            @loadingComplete="rendering = true"
            :key="videos_component_key"
            @changeKey="videos_component_key = `f${(~~(Math.random()*1e8)).toString(16)}`"
        />


        <div class="video-editor-page__footer" id="video-editor-page__footer">

            <app-price-component
                :price="price"
                @clickPrice="clickPrice"
            />

          <carousel
              :perPageCustom="[[150, 3], [370, 3], [460, 4], [560, 5], [685, 6], [900, 8], [1200, 10]]"
              :paginationEnabled="true"
              :spacePadding="16"
          >
            <slide
                v-for="(item, index) in videos"
                :key="`${item.id}__${index}_swiper`"
            >
              <app-one-video
                  :key="`${item.id}__${index}_one-video`"
                  :index="index"
                  :id="item.id"
                  :text="item.text"
                  :img="item.img"
                  :name="item.name"
                  :status="item.status"
                  :textStatus="false"
                  :timecode="true"
                  :duration="item.duration"
                  :video="item.video"
                  :type="item.type"
                  :descr="item.descr"
                  :control="item.control"
                  :webm="item.webm"
                  :playButton="item.playButton"
                  width="80px"
                  height="80px"
                  @clickVideo="(data) => video_editor_click_video(context, data)"
              />
            </slide>
            <slide>
              <div
                  v-if="checkMaxVideo"
                  class="video-editor-page__image"
                  @click="$router.push('/add-content')"
                  >
                  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d)">
                      <circle cx="32" cy="32" r="22" fill="white"/>
                    </g>
                    <path d="M27 32H37M32 27C32 30.9052 32 33.0948 32 37" stroke="#31283D" stroke-width="2"/>
                    <defs>
                      <filter id="filter0_d" x="0" y="0" width="64" height="64" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                        <feOffset/>
                        <feGaussianBlur stdDeviation="5"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0.545833 0 0 0 0 0.8365 0 0 0 0 1 0 0 0 0.5 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
               </div>
            </slide>
          </carousel>
            <div class="video-editor-page__music"
                id="video-editor-page__music"
                v-if="music"
                :class="{'video-editor-page__music-active' : musicActive}"
            >
                <app-music-view
                    :music="music"
                    :audio="music.file"
                    :id="music.id"
                    @clickMusic="(payload) => video_editor_click_music(context, payload)"
                />
            </div>

            <div class="video-editor-page__button"
                 v-if="!temporaryData"
                 :class="{ 'video-editor-page__button-active' : !temporaryData && checkVideos,  }"
                 @click="video_editor_proceed(context)"
            >
              <div class="video-editor-page__button-text"
                   :class="{'video-editor-page__button-text-active' : !temporaryData && checkVideos}"
              >
                Перейти к бронированию
              </div>
            </div>

            <app-edit-one-element
                v-show="editElementStatus"
                key="edit_one_element"
                :buttonDelete="buttonDelete"
                :buttonReplacement="buttonReplacement"
                :info="temporaryData"
                @clickDelete="(info) => video_editor_click_delete(context, info)"
                @clickReplacement="(info) => video_editor_click_replacement(context, info)"
            />
        </div>

        <transition
            name="fade-menu"
            appear
            mode="out-in"
        >
            <app-menu
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >

        <transition
            name="fade-overlay"
            appear
            mode="out-in"
        >
            <app-overlay
                v-if="overlay"
            />
        </transition>

        <transition
            name="default-fade"
            appear
            mode="out-in"
        >
          <app-popup-color
              v-if="alert.status"
              :is_slot="true"
              @clickButton="() => {
                alert.status = false
                overlay = false
              }"
          >
            <template
                v-slot:header
            >
              <div v-if="alert.step === 1" class="video-editor-page__hint-video">
                Нажмите + для добавления видео и текста.
              </div>

              <div v-if="alert.step === 2" class="video-editor-page__hint-video">
                Нужно выбрать как минимум 4 блока, чтобы завершить ролик!
              </div>

              <div v-if="alert.step === 3" class="video-editor-page__hint-video">
                Последний блок должен быть с видео!<br> Вы можете добавить его нажав на +
              </div>

            </template>
          </app-popup-color>
        </transition>

        <transition
            name="default-fade"
            appear
            mode="out-in"
        >
            <app-popup
                :text="popup.text"
                :growButton="popup.growButton"
                :moreText="popup.moreText"
                v-if="popup.value"
                @clickCancelPopup="close_popup(context)"
                @clickDeletePopup="video_editor_click_delete_popup(context)"
                @clickGrowButtonPopup="close_popup(context)"
            />
        </transition>

      <transition
          name="default-fade"
          appear
          mode="out-in"
      >
        <app-popup
            v-if="alert.price"
            :growButton="true"
            :is_slot="true"
            @clickGrowButtonPopup="() => {
            alert.price = false
            overlay = false
          }"
        >
          <template
              v-slot:header
          >
            <div class="video-editor-page__hint-price">
              Это предварительная стоимость
            </div>

            <div class="video-editor-page__hint-price" style="margin-top: 10px;">
              В зависимости от даты и времени показа стоимость может измениться.
            </div>

            <div class="video-editor-page__hint-price" style="margin-top: 10px;">
              Обратите внимание, что стоимость ролика рассчитывается от минуты.
            </div>

            <div class="video-editor-page__hint-price" style="margin-top: 10px;">
              Поэтому не стесняйтесь добавлять больше блоков :)
            </div>

          </template>
        </app-popup>
      </transition>

    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    const AppLoading = () => import('@/components/loading.vue')
    const NewPlayer = () => import('@/components/new-player')
    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')
    const AppPopup = () => import('@/components/popups/popup.vue')
    const AppPopupColor = () => import('@/components/popups/popup-color.vue')
    const AppOneVideo = () => import('@/components/one-video.vue')
    const AppEditOneElement = () => import('@/components/edit-one-element.vue')
    const AppMusicView = () => import('@/components/music-view.vue')
    const AppPriceComponent = () => import('@/components/price-editor-page.vue')
    const AppPlayerNoBlob = () => import('@/components/player-no-blob')
    // const AppPlayerEditor = () => import('@/components/player-editor/player-editor.vue')
    import { Carousel, Slide } from 'vue-carousel';


    import video_editor_set_videos from "@/views/video_editor/modules/video_editor_set_videos";
    import change_menu from "@/views/theme/modules/change_menu";
    import video_editor_click_video from "@/views/video_editor/modules/video_editor_click_video";
    import set_popups from "@/views/video_editor/modules/set_popups";
    import video_editor_click_delete from "@/views/video_editor/modules/video_editor_click_delete";
    import video_editor_proceed from "@/views/video_editor/modules/video_editor_proceed";
    import video_editor_click_replacement from "@/views/video_editor/modules/video_editor_click_replacement";
    import close_popup from "@/views/video_editor/modules/close_popup";
    import video_editor_delete_two_element from "@/views/video_editor/modules/video_editor_delete_two_element";
    import video_editor_delete_one_element from "@/views/video_editor/modules/video_editor_delete_one_element";
    import video_editor_click_delete_popup from "@/views/video_editor/modules/video_editor_click_delete_popup";
    import video_editor_click_music from "@/views/video_editor/modules/video_editor_click_music";

    export default {
      async created() {
        await this.video_editor_set_videos(this)
      },
      mounted() {
        let pagination = document.getElementsByClassName('VueCarousel-pagination')
        let el = pagination[0].children[0].children

        setTimeout(() => {
          el[el.length - 1].click()
        }, 0)
        window.addEventListener("orientationchange", this.dropSettingsPlayer)
      },
      destroyed() {
        clearInterval(this.interval_check_loading)
        window.removeEventListener("orientationchange", this.dropSettingsPlayer)
      },
      components: {
            AppLoading,
            AppHeader,
            AppMenu,
            AppOverlay,
            Carousel,
            Slide,
            AppOneVideo,
            AppEditOneElement,
            AppPopup,
            AppPopupColor,
            AppMusicView,
            AppPriceComponent,
            // AppPlayerEditor,
            NewPlayer,
            AppPlayerNoBlob
        },
        watch: {
            main: {
              async handler(val) {
                this.videos = []

                await this.entry.forEach(item => {
                  this.videos.push(item)
                })

                await this.main.forEach(item => {
                  this.videos.push(item)
                })

                await this.ending.forEach(item => {
                  this.videos.push(item)
                })

                this.videos_component_key = `f${(~~(Math.random()*1e8)).toString(16)}`

              },
              deep: false
            },
            temporaryData(val) {
              this.musicActive = val.type === 'music'
            },
            duration(val) {
              this.$store.dispatch('timer/setAllDuration', {time: val })
            }
        },
        data() {
            return {
              context: this,
              videos: [],
              temp: false,
              rendering: false,
              access_play: false,
              readyState: false,
              overlay: false,
              playingStatus: false,
              interval_check_loading: false,
              videos_component_key: `f${(~~(Math.random()*1e8)).toString(16)}`,
              popup: {
                value: false,
                text: '',
                growButton: false
              },
              menu: false,
              buttonDelete: true,
              buttonReplacement: true,
              temporaryData: false,
              editElementStatus: false,
              musicActive: false,
              alert: {
                status: false,
                step: 1,
                price: false
              }
            }
        },
        methods: {
          video_editor_set_videos,
          change_menu,
          video_editor_click_video,
          set_popups,
          video_editor_click_delete,
          video_editor_proceed,
          video_editor_click_replacement,
          close_popup,
          video_editor_delete_two_element,
          video_editor_delete_one_element,
          video_editor_click_delete_popup,
          video_editor_click_music,
          dropSettingsPlayer() {
            setTimeout(() => {
              this.videos_component_key = `f${(~~(Math.random()*1e8)).toString(16)}`
              this.$store.dispatch('timer/setCurrentDuration', {
                time: 0
              })
              let music = document.getElementById(`${this.music.id}`)
              if(music) {
                music.pause()
                music.currentTime = 0
              }
            }, 50)
          },
          async clickPrice() {
            this.overlay = true
            this.alert.price = true
          }
        },
        computed: {
          ...mapGetters({
            entry: 'entry_video/entry',
            main: 'main_videos/main',
            ending: 'ending_video/ending',
            music: 'music/music',
            price: 'price/price',
            duration: 'price/duration',
            allDuration: 'timer/all_duration',
            currentDuration: 'timer/current_duration'
          }),
          loading() {
            return !(this.rendering && this.videos.length)
          },
          addImage() {
            return require('~/assets/' + 'add.png')
          },
          checkVideos() {
            return this.main.length >= 3 && this.main[this.main.length - 1].type !== 'text'
          },
          maxBlocks() {
            return this.$store.getters['settings/maxBlocks']
          },
          checkMaxVideo() {
            return this.main.length < (this.maxBlocks - 2)
          }
        }
    }
</script>

<style lang="less">

    .video-editor-page {
        background-color: black;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        min-height: 500px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
        overflow: hidden;
    }

    #video-editor-page .header-component {
        z-index: 10;
    }

    @keyframes rotating {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .video-editor-page__footer {
        width: 100%;
        background-color: #2F1F4C;
        z-index: 10;
        position: relative;
    }

    #video-editor-page__footer .VueCarousel {
      min-height: 116px;
      //min-width: 360px;
    }

    #video-editor-page__footer .VueCarousel-wrapper {
      padding-top: 16px;
    }

    #video-editor-page__footer .VueCarousel-slide:last-child {
      //max-width: 104px;
      //min-width: 104px;
      min-width: 115px;
      max-width: 115px;
      margin-left: -53px;
    }

    #video-editor-page__footer .VueCarousel-pagination {
      display: none;
    }

    #video-editor-page__footer .edit-one-element {
      position: relative;
      min-height: 70px;
      margin: 0;
    }

    .video-editor-page__image {
      z-index: 5;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      min-height: 84px;
      padding-left: 17px;
    }

    .video-editor-page__music {
      position: relative;
      min-height: 40px;
      display: flex;
      border-radius: 5px;
      margin-left: 16px;
      cursor: pointer;
    }

    .video-editor-page__music-active {
        box-shadow: 0px 0px 4px rgba(255, 255, 255, 0.4), 0px 0px 10px rgba(143, 0, 255, 0.8);
    }


    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .video-editor-page__button-wrapepr {
      width: 100%;
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
      min-height: 86px;
    }

    .video-editor-page__button {
      height: 44px;
      min-height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      margin: 0 auto;
      margin-top: 12px;
      margin-left: 16px;
      margin-right: 16px;
      margin-bottom: 16px;
      cursor: pointer;
    }

    .video-editor-page__button-text {
        font-family: 'Montserrat-Medium';
        opacity: .5;
        color:  #FFFFFF;
        line-height: 12px;
        font-size: 16px;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .video-editor-page__hint-video {
      text-align: center;
      font-size: 15px;
      color: #ffffff;
      margin-top: 10px;
      font-family: 'Roboto-Light';
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .video-editor-page__hint-price {
      text-align: center;
      font-size: 15px;
      color: #31283D;
      font-family: 'Roboto-Medium';
    }

    .video-editor-page__button-active {
        background: #FFFFFF;
        cursor: pointer;
    }

    .video-editor-page__button-text-active {
        color: #31283D;
        opacity: 1;
    }
</style>